<template>
  <b-modal
    id="calendarOperationModal"
    centered
    hide-header-close
    class="calendar-modal"
    :title="$t('calendar.title')"
    @hidden="onHidden"
  >
    <div class="row d-flex align-items-center justify-content-center">
      <div class="col-md-12 mb-2">
        <b-form-group
          :label="$t('operationDocument.linkGenerated')"
          class="medium-label"
          label-for="name-input"
        >
          <div class="row ml-1 mr-1">
            <b-form-input
              id="name-input"
              ref="urlInput"
              :value="calendrierUrl"
              class="col-md-11"
              disabled
              type="text"
            />
            <button
              type="button"
              class="show-action-btn text-center col-md-1"
              :title="$t('calendar.copy')"
              @click="copyUrl"
            >
              <copy-icon  size="16"/>
            </button>
          </div>
        </b-form-group>
      </div>
    </div>

    <b-tabs
      lazy
      nav-class="mb-3"
      :active-nav-item-class="'bold-text border-calendar-active'"
      :no-nav-style="true"
      :pills="false"
    >
      <b-tab active :title="$t('calendar.tab.google')">
        <p class="italic-text">
          {{ $t('calendar.instructions.google.note') }}
        </p>
        <ol class="pl-3">
          <li>{{ $t('calendar.instructions.google.step1') }}</li>
          <li>{{ $t('calendar.instructions.google.step2') }}</li>
          <li>{{ $t('calendar.instructions.google.step3') }}</li>
          <li>{{ $t('calendar.instructions.google.step4') }}</li>
          <li>{{ $t('calendar.instructions.google.step5') }}</li>
        </ol>
      </b-tab>

      <b-tab :title="$t('calendar.tab.apple')">
        <p class="italic-text">
          {{ $t('calendar.instructions.apple.note') }}
        </p>
        <ol class="pl-3">
          <li>{{ $t('calendar.instructions.apple.step1') }}</li>
          <li>{{ $t('calendar.instructions.apple.mac') }}</li>
          <li>
            {{ $t('calendar.instructions.apple.iosIntro') }}
            <ul class="pl-3 mb-2">
              <li>{{ $t('calendar.instructions.apple.iosPath') }}</li>
              <li>{{ $t('calendar.instructions.apple.iosPaste') }}</li>
            </ul>
          </li>
        </ol>
      </b-tab>

      <b-tab :title="$t('calendar.tab.outlook')">
        <p class="italic-text">
          {{ $t('calendar.instructions.outlook.note') }}
        </p>
        <ol class="pl-3">
          <li>{{ $t('calendar.instructions.outlook.step1') }}</li>
          <li>{{ $t('calendar.instructions.outlook.step2') }}</li>
          <li>{{ $t('calendar.instructions.outlook.step3') }}</li>
          <li>{{ $t('calendar.instructions.outlook.step4') }}</li>
          <li>{{ $t('calendar.instructions.outlook.step5') }}</li>
        </ol>
      </b-tab>
    </b-tabs>

    <template #modal-footer>
      <b-button variant="primary" @click="$bvModal.hide('calendarOperationModal')">
        {{ $t('Finish') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "CalendrierOperationModal",
  props: {
    calendrierUrl: { type: String, required: true },
  },
  methods: {
    async copyUrl() {
      try {
        await navigator.clipboard.writeText(this.calendrierUrl);
        this.$bvToast && this.$bvToast.toast(this.$t('calendar.copied'), {
          title: this.$t('calendar.title'),
          autoHideDelay: 2000,
          variant: "success",
          solid: true,
          toaster: "b-toaster-bottom-right",
        });
      } catch (e) {
        const el =
          this.$refs.urlInput && this.$refs.urlInput.$el
            ? this.$refs.urlInput.$el.querySelector("input")
            : null;
        if (el) {
          el.focus();
          el.select();
          document.execCommand("copy");
          this.$bvToast && this.$bvToast.toast(this.$t('calendar.copied'), {
            title: this.$t('calendar.title'),
            autoHideDelay: 2000,
            variant: "success",
            solid: true,
            toaster: "b-toaster-bottom-right",
          });
        }
      }
    },
    onHidden() {
      const el =
        this.$refs.urlInput && this.$refs.urlInput.$el
          ? this.$refs.urlInput.$el.querySelector("input")
          : null;
      if (el) el.blur();
    },
  },
};
</script>

<style>
#calendarOperationModal .nav[role="tablist"] {
  border-bottom: none !important;
}

#calendarOperationModal .nav-link {
  border: none !important;
  color: inherit;
}

#calendarOperationModal .nav-item.active .nav-link,
#calendarOperationModal .nav-link[aria-selected="true"] {
  border: none !important;
  border-bottom: 2px solid #9E0430 !important;
  font-weight: 700;
}

#calendarOperationModal .modal-body {
  min-height: 390px;
}

</style>



// WEBPACK FOOTER //
// src/views/operationBilan/components/CalendrierOperationModal.vue